import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'accent';
type Size = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  block?: boolean;
  /** Square padding for a button holding only an icon. Needs an aria-label. */
  iconOnly?: boolean;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  iconOnly = false,
  className = '',
  children,
  ...rest
}: ButtonProps) {
  const cls = [
    'vs-btn',
    `vs-btn--${variant}`,
    `vs-btn--${size}`,
    block ? 'vs-btn--block' : '',
    iconOnly ? 'vs-btn--icon' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
